import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'kiene-gewicht-eingeben-numberpad-dialog',
    templateUrl: './gewicht-eingeben-numberpad-dialog.component.html',
    styleUrls: ['./gewicht-eingeben-numberpad-dialog.component.scss'],
})
export class GewichtEingebenNumberpadDialogComponent implements OnInit {
    private readonly maxLength = 10;
    gewichtString = '';
    showAbteil = false;
    abteilCtrl = new UntypedFormControl();

    constructor(
        public dialogRef: MatDialogRef<GewichtEingebenNumberpadDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data,
    ) {}

    ngOnInit(): void {
        this.showAbteil = !!this.data?.showAbteil;
        this.abteilCtrl.setValue(this.data?.abteil ?? null);
        const initialGewicht = this.data?.gewicht;
        if (initialGewicht !== null && initialGewicht !== undefined && !Number.isNaN(Number(initialGewicht))) {
            this.gewichtString = Number(initialGewicht).toString().replace('.', ',');
        }
    }

    @HostListener('window:keydown', ['$event'])
    catchKeyboardDownEvent(event: KeyboardEvent) {
        if (this.isTextInput(event)) {
            return;
        }
        if (event.code === 'Enter' || event.code === 'NumpadEnter') {
            // Prevent focused keypad button from receiving Enter as click.
            event.preventDefault();
            event.stopPropagation();
            this.save();
        }
    }

    @HostListener('window:keyup', ['$event'])
    catchKeyboardEvent(event: KeyboardEvent) {
        if (this.isTextInput(event)) {
            return;
        }
        if (event.code === 'Enter' || event.code === 'NumpadEnter') {
            return;
        }

        const numericMatch = event.code.match(/^(Numpad|Digit)(\d)$/);
        if (numericMatch?.[2]) {
            this.addNumber(Number.parseInt(numericMatch[2], 10));
            return;
        }

        if (event.code.startsWith('Numpad') || event.code.startsWith('Digit')) {
            const splitted = event.code.split(/Numpad|Digit/);
            if (splitted && splitted[1]) {
                const parsed = Number.parseInt(splitted[1], 10);
                if (!Number.isNaN(parsed)) {
                    this.addNumber(parsed);
                }
            }
        } else if (event.code === 'Backspace') {
            this.backspace();
        }
    }

    private isTextInput(event: KeyboardEvent): boolean {
        const target = event.target as HTMLElement | null;
        if (!target) {
            return false;
        }
        const tag = target.tagName;
        return tag === 'INPUT' || tag === 'TEXTAREA' || target.isContentEditable;
    }

    addNumber(value: number) {
        if (!Number.isInteger(value) || value < 0 || value > 9 || this.gewichtString.length >= this.maxLength) {
            return;
        }
        this.gewichtString += value.toString();
    }

    comma() {
        if (this.gewichtString.includes(',') || this.gewichtString.length >= this.maxLength) {
            return;
        }
        this.gewichtString += ',';
    }

    backspace() {
        this.gewichtString = this.gewichtString.substring(0, this.gewichtString.length - 1);
    }

    close() {
        this.dialogRef.close();
    }

    save() {
        const numberStr = this.gewichtString.replace(',', '.');
        const weight = Number.parseFloat(numberStr);
        if (this.showAbteil) {
            const abteil = this.abteilCtrl.value?.toString()?.trim() || null;
            this.dialogRef.close({ gewicht: Number.isNaN(weight) ? null : weight, abteil });
            return;
        }
        this.dialogRef.close(weight);
    }
}
